export enum AutomationTab {
  Overview,
  Activity,
  Template,
}
